import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/siteData';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<string | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (name: string, url: string) => {
    setSelected(name);
    setIsOpen(false);
    window.open(url, '_blank', 'noopener,nofollow');
  };

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-2">
            Browse Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-6">
            Select a category to explore products on our main spreadsheet platform
          </p>

          <div ref={dropdownRef} className="relative inline-block w-full max-w-md">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="w-full flex items-center justify-between gap-3 px-5 py-3.5 rounded-xl bg-background-100 border border-background-200 text-foreground-800 text-sm md:text-base font-medium hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <span className={selected ? 'text-foreground-900' : 'text-foreground-500'}>
                {selected || 'Choose a category...'}
              </span>
              <i className={`ri-arrow-down-s-line text-lg transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
            </button>

            {isOpen && (
              <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200 rounded-xl shadow-lg z-40 max-h-72 overflow-y-auto">
                {categories.map((cat) => (
                  <button
                    key={cat.name}
                    onClick={() => handleSelect(cat.name, cat.url)}
                    className="w-full flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors text-left cursor-pointer first:rounded-t-xl last:rounded-b-xl"
                  >
                    <div className="w-7 h-7 flex items-center justify-center">
                      <i className={`${cat.icon} text-base text-primary-500`}></i>
                    </div>
                    <span>{cat.name}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}